var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefresh3 = function SvgRefresh3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6C14.0589 6 6 14.0589 6 24C6 25.1046 5.10457 26 4 26C2.89543 26 2 25.1046 2 24C2 11.8497 11.8497 2 24 2C31.6798 2 38.4391 5.93668 42.3716 11.8928C42.9801 12.8146 42.7262 14.0552 41.8045 14.6638C40.8827 15.2724 39.6421 15.0185 39.0335 14.0967C35.8099 9.21428 30.2799 6 24 6Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 22C45.1045 22 46 22.8954 46 24C46 36.1503 36.1502 46 24 46C16.3202 46 9.56083 42.0633 5.62842 36.1072L8.96651 33.9033C12.19 38.7857 17.7201 42 24 42C33.9411 42 42 33.9411 42 24C42 22.8954 42.8954 22 44 22Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 2C43.1046 2 44 2.89543 44 4V14C44 15.1046 43.1046 16 42 16H32C30.8954 16 30 15.1046 30 14C30 12.8954 30.8954 12 32 12H40V4C40 2.89543 40.8954 2 42 2Z",
    fill: "#082244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 34C4 32.8954 4.89543 32 6 32H16V36H8V44C8 45.1046 7.10457 46 6 46C4.89543 46 4 45.1046 4 44V34Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh3.dd66b710.svg";
export { ForwardRef as ReactComponent };